<template src="./ratePlanDetail.template.html"></template>
<script>
  import * as axios from "axios";
  import $ from "jquery";
  import moment from "moment-timezone";

  export default {
    // options
    name: "ratePlanDetail",
    props: ["unitTypeId"],
    data() {
      return {
        statusList: [],
        policyList: [],
        displaySectionValue: "ratePlanInfo1",
        ratePlanData: {

        },
        ratePlanList: [],
        rates: null,
        statusId: 1,
        // showPolicy: true,
        // showPolicies: false,
        showpolicybutton: false,
        ratePlanStatus: {
          StatusId: 1,
          StatusName: "Active"
        },
        // isDerived: false,
        MinStayValue: "",
        MinStay: null,
        minStayColor: "whiteColor",
        changeInRestriction: false,
        PromoCodesList: [],
        promocode: null,
        DerivedOffsetAmount: "",
           checkInList:[],
           checkOutList:[],
        
      };
    },

    methods: {
      ratePlanMinStayValueCheck(ratePlanMinStayValue){
        let vm = this;
        if(ratePlanMinStayValue < 1){
          vm.ratePlanData.MinStay = null
        }
      },
      promocodesUi(PromoCodesList) {
        return PromoCodesList.join(", ")
      },
      checkinUi(checkinList){
        return checkinList.join(", ")
      },
        checkoutUi(checkoutList){
        return checkoutList.join(", ")
      },
      displaySection(displaySectionValue) {
        let vm = this;
        vm.displaySectionValue = displaySectionValue;
      },
      addToLoop: function (number) {
        let vm = this;
        vm.showpolicybutton = true;
        vm.policyList.push({});
        console.log("policyList", vm.policyList);
        // if (!vm.ratePlanData.hasOwnProperty('policyData')) {
        //   vm.ratePlanData.policyData = {
        //     ContentTitle: "",
        //     Description: "",
        //     StatusId: null
        //   }
        // }
      },
      removeSearchTextFromColumn(selectedText) {
        let vm = this;
        vm.ratePlanData.PromoCodes = null;
        if (vm.PromoCodesList.indexOf(selectedText) > -1) {
          vm.PromoCodesList.splice(vm.PromoCodesList.indexOf(selectedText), 1);
        } else if (vm.promocode) {
          vm.promocode = null;
        }
      },
      addSearcTextToColumn() {
        if (this.promocode != null) {
          this.PromoCodesList.push(this.promocode);
          this.promocode = null;
        }
      },

      addSearchText(event) {
        if (event.key == "Enter") {
          if (this.promocode != null) {
            this.PromoCodesList.push(this.promocode);
            this.promocode = null;
          }
        }
      },

      getPolicyTitle(policy) {
        let vm = this;
        vm.ratePlanData.policyData.ContentId = policy.ContentId;
        vm.ratePlanData.policyData.StatusId = policy.StatusId;
        vm.ratePlanData.policyData.ContentTitle = policy.ContentTitle;
        vm.ratePlanData.policyData.Description = policy.Content;
      },
      getPolicyDesc(policy) {
        let vm = this;
        vm.ratePlanData.policyData.ContentId = policy.ContentId;
        vm.ratePlanData.policyData.StatusId = policy.StatusId;
        vm.ratePlanData.policyData.ContentTitle = policy.ContentTitle;
        vm.ratePlanData.policyData.Description = policy.Content;
      },
      getPolicyStatus(policy) {
        let vm = this;
        vm.ratePlanData.policyData.ContentId = policy.ContentId;
        vm.ratePlanData.policyData.StatusId = policy.StatusId;
        vm.ratePlanData.policyData.ContentTitle = policy.ContentTitle;
        vm.ratePlanData.policyData.Description = policy.Content;
      },

      minusMinStayValue() {
        let vm = this;
        console.log(vm.ratePlanData)
        if (vm.ratePlanData && vm.ratePlanData.MinStay == null) {
          vm.ratePlanData.MinStay = 1
        }
        else {
          if (vm.ratePlanData && vm.ratePlanData.MinStay > 1) {
            let val = parseInt(vm.ratePlanData.MinStay)
            val -= 1;
            vm.ratePlanData.MinStay = val
          }

        }
      },
      plusMinStayValue() {
        let vm = this;
        if (vm.ratePlanData && vm.ratePlanData.MinStay == null) {
          vm.ratePlanData.MinStay = 1
        }
        else {
          let val = parseInt(vm.ratePlanData.MinStay)
          val += 1;
          vm.ratePlanData.MinStay = val
        }
      },
      minusMinStay(ratePlanData) {
        let scope = this;
        scope.ratePlanData.IsPositive = false
        // let val = Number(scope.ratePlanData.DerivedOffsetAmount)
        // val = "-" + val;
        // this.DerivedOffsetAmount = val
      },
      plusMinStay(ratePlanData) {
        let scope = this;
        scope.ratePlanData.IsPositive = true
        // let val = Number(scope.ratePlanData.DerivedOffsetAmount)
        // val = "+" + val;
        // this.DerivedOffsetAmount = val

      },
      getPropertyMetaData: function () {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("GetPropertiesBySearchText==>", response);
              vm.statusList.splice(
                0,
                vm.statusList.length,
                ...response.statusList
              );
            }
          }
        });
      },

      // isDerivedCheck(e) {
      //   let vm = this;
      //   if (e.target.checked) {
      //     vm.ratePlanData.isDerived = !vm.ratePlanData.isDerived;
      //   }
      // },
      Get_RatePlanDetail() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_RatePlanDetail",
          params: {
            ModuleAction: "Get_RatePlanDetail",
            ratePlanId: vm.$route.params.ratePlanId
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Get_RatePlanDetail", err);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "In getting rate plan detail"
              });
            }
            if (response) {
              console.log("response of Get_RatePlanDetail", response);
              if (response[1] && response[1][0]) {
                vm.ratePlanData = response[1][0];
                if (vm.ratePlanData.StatusId != null) {
                  vm.ratePlanStatus.StatusId = vm.ratePlanData.StatusId;
                  vm.ratePlanStatus.StatusName = vm.ratePlanData.StatusName;
                }
                vm.$set(vm.ratePlanData, "policyData", {
                  ContentId: null,
                  ContentTitle: "",
                  Description: "",
                  StatusId: null
                })
                if (vm.ratePlanData.PromoCodes) {
                  vm.PromoCodesList = vm.ratePlanData.PromoCodes.split(",")
                }
              }
              if (response[2]) {
                vm.policyList = response[2]
              }
              if(response[3] && response[3][0] ){
                let checkin = response[3][0];
                if(checkin.CheckIn){
               vm.checkInList = checkin.CheckIn.split(",")
                }
             

              }
               if(response[4] && response[4][0] ){
                 let checkout = response[4][0]
                 if(checkout.CheckOut){
                  vm.checkOutList = checkout.CheckOut.split(",")
                 }
                
              }
            }
          }
        });
      },
      Get_RatePlanList() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_RatePlanList",
          params: {
            ModuleAction: "Get_RatePlanList",
            ratePlanId: ''
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Get_RatePlanList", err);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "In getting rate plan list"
              });
            }
            if (response) {
              console.log("response of Get_RatePlanList", response);
              if (response[1]) {
                vm.ratePlanList = response[1];

              }
            }
          }
        });
      },
      changeDerivedOffsetAmount(e){
        let vm = this;
        if(!e.target.checked){
          vm.ratePlanData.DerivedOffsetAmount = null;
        }
      },
      saveRatePlanInfo(sectionName) {
        let vm = this;
        if (sectionName == "ratePlanInfo1" && !vm.ratePlanData.RatePlan_Name) {
           vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Enter rateplan detail"
          });
          return
        }
        if (sectionName == "ratePlanInfo2" && (vm.$route.params.ratePlanId == -1 || vm.$route.params.ratePlanId == null || vm.$route.params.ratePlanId == undefined)) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "save rateplan"
          });
          return
        }
        if(vm.ratePlanData.IsDerived && (!vm.ratePlanData.ParentRatePlanId || !vm.ratePlanData.DerivedOffsetAmount)){
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "Please enter select rateplan and enter offset amount"
          });
          return
        };
        if (!vm.ratePlanData.IsDerived) {
          vm.ratePlanData.ParentRatePlanId = null;
          vm.ratePlanData.DerivedOffsetAmount = null;
        }
        if (vm.ratePlanData.IsPositive == true || vm.ratePlanData.IsPositive == 1) {
          vm.DerivedOffsetAmount = vm.ratePlanData.DerivedOffsetAmount ? "+" + vm.ratePlanData.DerivedOffsetAmount : 0
          // vm.DerivedOffsetAmount = "+" + rate
        }
        else {
          vm.DerivedOffsetAmount = vm.ratePlanData.DerivedOffsetAmount ? "-" + vm.ratePlanData.DerivedOffsetAmount : 0
          // vm.DerivedOffsetAmount = "-" + rate
        }
        if (vm.PromoCodesList && vm.PromoCodesList.length > 0) {
          vm.ratePlanData.PromoCodes = vm.PromoCodesList.length > 0 ? vm.PromoCodesList.join() : null
          console.log("test", vm.ratePlanData.PromoCodes)
        }
        vm.$store.dispatch("dataRequestHandler", {
          key: "Save_RatePlanDetails",
          params: {
            ModuleAction: "Save_RatePlanDetails",
            ratePlanData: vm.ratePlanData,
            PromoCodes: vm.ratePlanData.PromoCodes,
            statusId: vm.ratePlanStatus.StatusId,
            DerivedOffsetAmount: vm.DerivedOffsetAmount ? vm.DerivedOffsetAmount : vm.ratePlanData.DerivedOffsetAmount,
            MinStay: vm.ratePlanData.MinStay

          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Save_RatePlanDetails", err);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Error",
                message: "In saving rate plan"
              });
            }
            if (response) {
              console.log("response of Save_RatePlanDetails", response);

              if(sectionName == "ratePlanInfo1"){
              vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Rate Plan Detail saved successfully"
              });
               }
               else if(sectionName == "ratePlanInfo2"){
                  vm.$store.dispatch("toastr", {
                type: "success",
                header: "Success!",
                message: "Rate Plan Detail Restrictions saved successfully"
              });
               }

              if (response.recordsets[1] && response.recordsets[1][0] && response.recordsets[1][0].RatePlanId) {
                vm.$router.push("/ratePlanDetail/" + response.recordsets[1][0].RatePlanId);

                vm.Get_RatePlanDetail();

              }
            }
          }
        });
      },

      addPercent(ratePlanData) {
        let scope = this;
        // if (scope.ratePlanData.DerivedOffsetAmount && scope.ratePlanData.DerivedOffsetAmount.indexOf('$') > -1) {
        //   scope.ratePlanData.DerivedOffsetAmount = scope.ratePlanData.DerivedOffsetAmount.replace("$", "")
        // }
        // scope.ratePlanData.DerivedOffsetAmount = scope.ratePlanData.DerivedOffsetAmount + "%";
        scope.ratePlanData.IsPercent = true;
        // scope.noPercent = false;
        // scope.yesPercent = true;
      },
      addDollar(ratePlanData) {
        let scope = this;
        // if (scope.ratePlanData.DerivedOffsetAmount && scope.ratePlanData.DerivedOffsetAmount.indexOf('%') > -1) {
        //   scope.ratePlanData.DerivedOffsetAmount = scope.ratePlanData.DerivedOffsetAmount.replace("%", "")
        // }
        // scope.ratePlanData.DerivedOffsetAmount = "$" + scope.ratePlanData.DerivedOffsetAmount;
        scope.ratePlanData.IsPercent = false;
        // scope.noPercent = true;
        // scope.yesPercent = false;
      },
      // saveDerivedValue() {
      //   let scope = this;
      //   if (scope.ratePlanData.IsPercent === null) {
      //     scope.ratePlanData.IsPercent = true;
      //   }
      //   if (scope.ratePlanData.IsPercent) {
      //     scope.ratePlanData.DerivedOffsetAmount = scope.DerivedOffsetAmount + "%";
      //   } else {
      //     scope.ratePlanData.DerivedOffsetAmount = "$" + scope.DerivedOffsetAmount;
      //   }
      // },

      SaveRatePlanPolicyDetails: function () {
        let vm = this;
        if (vm.$route.params.ratePlanId == -1) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning",
            message: "please enter rate plan details"
          });
        } else {
          vm.$store.dispatch("dataRequestHandler", {
            key: "Save_RatePlan_Policies",
            params: {
              ModuleAction: "Save_RatePlan_Policies",
              ContentId: vm.ContentId,
              RatePlanId: vm.ratePlanData.RatePlanId,
              // propertyId:-1,
              policyData: vm.ratePlanData.policyData
            },
            callback: function (err, response) {
              if (err) {
                console.error("Error has occured => ", err);
                vm.$store.dispatch("toastr", {
                  type: "error",
                  header: "error!",
                  message: error.sqlMessage ? error.sqlMessage : err
                });
                return;
              } else if (response) {
                vm.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "Rate Plan Detail Policy saved successfully"
                });
              }
              vm.Get_RatePlanDetail();
            }
          });
        }
      }
    },

    computed: {},

    watch: {
      "ratePlanData.RatePlan_Name": function (oldvalue, newvalue) {
        let vm = this;
        if (newvalue) {
          vm.ratePlanData.RatePlan_DisplayName = oldvalue;
        }
      }
    },
    created() { },
    mounted() {
      let vm = this;
      vm.getPropertyMetaData();
      vm.Get_RatePlanList();
      vm.Get_RatePlanDetail();
    }
  };
</script>